import { Circle } from '@/domain/dienstplan/features/VisualEditor/types';
import { useVisualEditorContext } from '@/domain/dienstplan/features/VisualEditor/VisualEditorContext';
import {
  MITARBEITER_THRESHOLD,
  STUNDEN_MAX,
} from '@/domain/dienstplan/shared/utils/constants';
import { Circle as VisxCircle, Line } from '@visx/shape';

export function Cursor({ circle }: { circle: Circle | undefined }) {
  const { yScalePoint, xScalePoint, maxMitarbeiterAnzahl } =
    useVisualEditorContext();

  return (
    <>
      <Line
        from={{ x: circle?.cx, y: yScalePoint(0) }}
        to={{
          x: circle?.cx,
          y: yScalePoint(
            maxMitarbeiterAnzahl.yAxisValue + MITARBEITER_THRESHOLD,
          ),
        }}
        stroke="#d3d3d3"
        strokeWidth={1}
        strokeDasharray="3,2"
        style={{ pointerEvents: 'none' }}
      />
      <Line
        from={{ x: xScalePoint(0), y: circle?.cy }}
        to={{ x: xScalePoint(STUNDEN_MAX), y: circle?.cy }}
        stroke="#d3d3d3"
        strokeWidth={1}
        strokeDasharray="3,2"
        style={{ pointerEvents: 'none' }}
      />
      <VisxCircle
        r={circle?.r}
        cx={circle?.cx}
        cy={circle?.cy}
        fill="#8E8E93"
        style={{ pointerEvents: 'none' }}
      />
    </>
  );
}
